import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Alert,
  CircularProgress,
} from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const Pricing = () => {
  const [sessionPrice, setSessionPrice] = React.useState("");
  const [durationMinutes, setDurationMinutes] = React.useState(60);
  const [breakdown, setBreakdown] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const compute = async () => {
    if (!sessionPrice) return;
    setLoading(true);
    try {
      const params = new URLSearchParams({
        sessionPrice: String(sessionPrice),
        durationMinutes: String(durationMinutes || 60),
      });
      const { json } = await httpClient(`${API_BASE_URL}/pricing/breakdown?${params}`);
      setBreakdown(json);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <CalculateIcon /> Calcul de prix (breakdown)
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Outil de calcul détaillé du prix d'une consultation : tarif pro + frais ioUman + TVA.
      </Alert>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Stack spacing={2}>
            <Stack direction="row" spacing={1}>
              <TextField size="small" type="number" label="Prix séance (€)" value={sessionPrice}
                onChange={(e) => setSessionPrice(e.target.value)} />
              <TextField size="small" type="number" label="Durée (min)"
                value={durationMinutes} onChange={(e) => setDurationMinutes(Number(e.target.value))} />
            </Stack>
            <Box>
              <Button variant="contained" onClick={compute}
                disabled={loading || !sessionPrice}>
                {loading ? <CircularProgress size={18} /> : "Calculer"}
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
      {breakdown && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Résultat</Typography>
            <Box component="pre" sx={{
              bgcolor: "#f5f7fa", p: 2, borderRadius: 1,
              fontSize: 13, maxHeight: 400, overflow: "auto",
            }}>
              {JSON.stringify(breakdown, null, 2)}
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default { list: Pricing };
